module.exports = __webpack_public_path__ + "media/luxury-2026/location-green-study-e8f100cd.jpg";